// ABOUTME: The tab's market state from the `/api/user` session, and the action switching it.
// ABOUTME: Switching stores the market for this tab and reloads it, so every query is refetched.

import { useAuth } from '@src/hooks';
import { useCallback } from 'react';

import type { MarketContext, MarketRef } from '../types';
import { switchActiveMarket } from '../utils/switchActiveMarket';

export type UseActiveMarketResult = {
    /** the market module is switched on for the tenant */
    isEnabled: boolean;
    marketContext: MarketContext | undefined;
    activeMarketId: string | null;
    activeMarket: MarketRef | undefined;
    allowedMarkets: MarketRef[];
    switchMarket: (marketId: string, options?: { then?: string }) => void;
};

export function useActiveMarket(): UseActiveMarketResult {
    const { sessionData } = useAuth();
    const marketContext = sessionData?.marketContext ?? undefined;
    const allowedMarkets = marketContext?.allowedMarkets ?? [];
    const activeMarketId = marketContext?.activeMarketId ?? null;

    const switchMarket = useCallback((marketId: string, options?: { then?: string }) => {
        switchActiveMarket(marketId, options?.then);
    }, []);

    return {
        isEnabled: !!marketContext,
        marketContext,
        activeMarketId,
        activeMarket: allowedMarkets.find(market => market.id === activeMarketId),
        allowedMarkets,
        switchMarket,
    };
}

export default useActiveMarket;
